module.exports = function() {
  return new Worker(__webpack_public_path__ + "worker.load-data.ebfb9367e97151c6ad7e.js");
};